module.exports = __webpack_public_path__ + "img/ambrascet80.aa527068.jpg";